import styled, { css } from 'styled-components';

export const BurgerLine = styled.span`
  background-color: ${p => p.theme.color.blue};
  border-radius: 10px;
  display: block;
  height: 4px;
  margin-top: 3px;
  transition: 0.25s;
  user-select: none;
  width: 100%;

  &:nth-of-type(1) {
    margin-top: 0;
  }

  ${p =>
    p.open &&
    css`
      &:nth-of-type(1) {
        transform: translateY(8px) rotate(135deg);
      }

      &:nth-of-type(2) {
        opacity: 0;
      }

      &:nth-of-type(3) {
        margin-top: 0;
        transform: translateY(-3px) rotate(-135deg);
      }
    `};
`;

export const SCBurger = styled.div`
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  cursor: pointer;
  outline: none;
  position: relative;
  transition: 0.5s ease-in-out;
  user-select: none;
  width: 100%;
`;

export const AttentionDot = styled.div`
  animation: ${p => p.theme.pulse} 1s infinite;
  background-color: ${p => p.theme.color.red};
  border-radius: 50%;
  display: ${p => (p.open ? 'none' : 'block')};
  height: 10px;
  position: absolute;
  right: -3px;
  top: -3px;
  width: 10px;
  z-index: 333;
`;



// WEBPACK FOOTER //
// ./src/components/Burger/styles.js